document.addEventListener('DOMContentLoaded', function() {
const tabsNav = document.getElementById('tabhNav');
const tabLinks = document.querySelectorAll('.tabh-nav a');
const tabContents = document.querySelectorAll('.tabh-content');
const offsetTop = tabsNav.offsetTop;
let topHeight=document.querySelector('.announcement-bar-section').offsetHeight + document.querySelector('.section-header').offsetHeight + document.querySelector('product-info').offsetHeight;
   
// 监听滚动事件
window.addEventListener('scroll', function() {
    // 固定tabs导航栏
    if (window.pageYOffset >= offsetTop+topHeight) {
        tabsNav.classList.add('fixed');
    } else {
        tabsNav.classList.remove('fixed');
    }
    
    // 高亮当前可见的tab
    let currentTab = '';
    tabContents.forEach(content => {
        const contentTop = content.offsetTop+topHeight;
        const contentHeight = content.offsetHeight;        
        if (window.pageYOffset >= contentTop - 100 && 
            window.pageYOffset < contentTop + contentHeight - 100) {
            currentTab = content.id;
        }
    });
    
    if (currentTab) {
        tabLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === `#${currentTab}`) {
                link.classList.add('active');
            }
        });
    }
});

// 点击切换tab并滚动到对应内容
    tabLinks.forEach(link => {
      link.addEventListener('click', () => {
        tabLinks.forEach(i => i.classList.remove('active'));
        link.classList.add('active');
        const targetId = link.getAttribute('href');
        document.querySelector(targetId).scrollIntoView({ behavior: 'smooth' });
      });
    });  
   document.getElementById('tab-ship').style.display = 'block'
});
